import { useEffect, useCallback } from "react";
import SelectWithSearch from "./components/SelectWithSearch";
import useFieldState from "./hooks/useFieldState";
import useEsri from "./hooks/useEsri";
import useForm from "./hooks/useForm";
import { APP_SETTINGS } from "./settings";
import { firstToUppercase, compare } from "./utils";
const queryParams = {
  where: "1=1",
  outFields: ["*"],
  returnGeometry: false,
};
const { ZONE_URL } = APP_SETTINGS.GIS_SERVER;
const ZoneLaList = () => {
  const { getSelectedQueryLayer, getSelectedYear } = useForm();
  const [fieldDataState, setFieldDataState] = useFieldState();
  const { queryLayer, esriLoader } = useEsri();
  const { areas } = fieldDataState;
  useEffect(() => {
    if (!esriLoader) return;
    const buildAreaList = async () => {
      const zonesResponse = await queryLayer(ZONE_URL, queryParams);
      const laResponse = await queryLayer(APP_SETTINGS.GIS_SERVER[`LA_${getSelectedYear}_URL`], queryParams);
      const orderedZoneAreas = zonesResponse.sort(compare);
      const orderedLaAreas = laResponse?.sort(compare);
      setFieldDataState((prevState) => ({
        ...prevState,
        areas: {
          ...prevState.areas,
          zone: orderedZoneAreas,
          la: orderedLaAreas,
        },
      }));
    };
    buildAreaList();
  }, [esriLoader, getSelectedYear, queryLayer, setFieldDataState]);
  const canAreaListBeDisplayed = useCallback(() => {
    return !(!getSelectedQueryLayer || !areas[getSelectedQueryLayer]);
  }, [areas, getSelectedQueryLayer]);
  return (
    <>
      {canAreaListBeDisplayed() && (
        <div className="mb-5">
          <SelectWithSearch
            name="zone_la_list"
            label={`${
              firstToUppercase(getSelectedQueryLayer) === "La"
                ? "Local Authority"
                : firstToUppercase(getSelectedQueryLayer)
            } List`}
            options={areas[getSelectedQueryLayer]}
          />
        </div>
      )}
    </>
  );
};
export default ZoneLaList;